export default {
  // RejectPhoneData
  selectClear: 'Deselect',
  rejectDataNumber: 'Opt-out Number',
  customerNumber: 'Customer Number',
  rejectDate: 'Unsubscribe Date',
  rejectDataState: 'Status',
  memberClassification: 'Member Type',
  memberPhone: 'Customer Number',
  title: 'Cancel Unsubscribe',
  clearMsg: 'Do you want to cancel the unsubscribe?',
  alertMsg: 'Please select an item to cancel.',
};
